import React, { useState } from 'react';

import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { useMutation } from 'react-query';
import { FinancialSupportService } from 'services/common';
import { getErrorText } from 'utils/geterrortext';
import { isUserLoggedIn } from 'utils/authentication';
import { useRouter } from 'next/router';

import ActionButton from '@core/components/actionbutton/ActionButton';
import TextAreaInput from '@core/components/textareainput/TextAreaInput';
import Modal from '@core/components/Modal/Modal';
import { Teacher, Danger, Messages1 } from 'iconsax-react';

import classes from './FinancialAid.module.scss';


const FinancialAid = ({ isBanner = true }) => {
    const router = useRouter();
    const { show, showModal, destroyModal } = UseModal();
    const { toast, ToastContainer } = UseToast();
    const [reason, setReason] = useState(null);
    const { mutate } = useMutation(FinancialSupportService, {
        onSuccess: () => {
            toast(
                'Financial support request submitted successfully.',
                'success'
            );
            destroyModal();
        },
        onError: (error) => {
            toast(
                getErrorText(error),
                'alert'
            );
        }
    });

    const submitForm = () => {
        if (!isUserLoggedIn())
            router.push('/login?next=/plans');
        else
            mutate({ reason });
    };

    return (
        <>
            {isBanner && (
                <div className={classes.wrapper}>
                    <div className='d-flex align-items-center gap-2'>
                        <div className={classes.icon}>
                            <Teacher size={24} variant='TwoTone' />
                        </div>
                        <p><strong>Student Discount</strong> Pharmuni offers up to 60% discount for eligible students who need financial aid.</p>
                    </div>
                    <ActionButton kind='blank' onClick={() => showModal()}>Request Student Discount</ActionButton>
                </div>
            )}
            {!isBanner && (
                <div className={classes['button-wrapper']}>
                    <ActionButton kind='blank' onClick={() => showModal()}>
                        <div className='d-flex align-items-center gap-1'>
                            <Messages1 variant='TwoTone' /> Request Student Discount
                        </div>
                    </ActionButton>
                </div>

            )}
            <Modal
                type={MOBILE_SLIDE_UP}
                title=""
                show={show}
                closeHandler={destroyModal}
                isGoPermium={true}
                header={false}
            >
                <div className={classes.modalContent}>
                    <div className='row'>
                        <div className='col-12 col-lg-6'>
                            <h3>Student Discount Request</h3>
                            <p className={classes.content}>
                               To give every pharma student a chance to learn and help the community grow, 
                               we have a student discount program.
                            </p>
                            <p className={classes.content}>
                                Pharmuni uses a Fair-Price policy, so everyone pays in local currency and purchasing power.
                                 If you’re a student and need help, you can request a <span>one-time discount for your first month or first year.</span>
                            </p>
                            <p className={classes.content}>
                                This program is limited—please request <span>only the discount amount (in percent) you need</span> so we can help more students.
                                Your subscription isn’t limited and includes everything in Pharmuni (see <a href='/plans'>Plans</a> and <a href='/benefits-hub'>Benefits Hub</a> to learn what Premium subscription offers).
                            </p>
                        </div>
                        <div className='col-12 col-lg-6'>
                            <h4>Why do you need this discount?</h4>

                            <TextAreaInput
                                input={{
                                    type: 'text',
                                    placeholder: 'Briefly describe your situation, why you need this financial aid, and how much you are able to pay. Do not include sensitive information.',
                                    name: 'reason',
                                    id: 'reason',
                                    value: reason,
                                    onChange: (e) => setReason(e.target.value),
                                }}
                                maxLength={500}
                            />
                            <div className='d-flex align-items-start gap-2 mt-3'>
                                <div>
                                    <Danger size={16} variant='TwoTone' />
                                </div>
                                <p className={classes.attention}>
                                    By clicking on Submit, I show my understanding that Pharmuni already uses Fair-Price local
                                    pricing, this program is limited, and approval isn’t guaranteed. Also, I agree to be contacted
                                    at my email.
                                </p>
                            </div>
                            <div className='d-flex justify-content-center flex-wrap flex-sm-nowrap gap-4 mt-5'>
                                <ActionButton kind='simple' onClick={destroyModal}>Cancel</ActionButton>
                                <ActionButton onClick={submitForm} kind='secondary_main' disabled={!reason}>
                                    Submit Request
                                </ActionButton>
                            </div>

                        </div>
                    </div>
                </div>
            </Modal>
            <ToastContainer />
        </>
    );
};

export default FinancialAid;